import { 
    SITE_DASHBOARD_SSID_LOAD_GRAPH_REQUEST,
	SITE_DASHBOARD_SSID_LOAD_GRAPH_SUCCESS,
	SITE_DASHBOARD_SSID_LOAD_GRAPH_FAIL
 } from "../../constants/graphConstants/customerAggrStatsGraphConstants";

/**
 * Reducer function for managing site dashboard  SSID load graph .
 *
 * @param {object} state - Current state of the user login.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const ssidLoadGraphReducer = (
	state = {
		loading: false,
        siteDashboardSSIDLoadGraph : {},
        error : null
	},
	action
) => {
	console.log("action.type", action)
	switch (action.type) {
		
		case SITE_DASHBOARD_SSID_LOAD_GRAPH_REQUEST:
			return {
				...state,
				siteDashboardSSIDLoadGraph : {},
				loading: true,
			};
		case SITE_DASHBOARD_SSID_LOAD_GRAPH_SUCCESS:
			return {
				...state,
				siteDashboardSSIDLoadGraph: action.payload,
				loading: false,
			};
		case SITE_DASHBOARD_SSID_LOAD_GRAPH_FAIL:
			return {
                ...state,
                siteDashboardSSIDLoadGraph : {},
				error: action.payload,
				loading: false,
			};
		default:
			return state;
	}
};